import { UserRoles as Roles } from "@/Domain/UserRoles";

export interface RoleGroup {
  roles: string[];
  validateRestrictionsAsync?: () => Promise<boolean>;
}

export const RCorRcSupportStaffGroup: RoleGroup = {
  roles: Roles.ROLES_ALL_RC,
};

export const OUInternalStaff: RoleGroup = {
  roles: Roles.ROLES_ALL_INTERNAL_STAFF,
};

export const RfrGroup = {
  roles: Roles.ROLES_ALL_RFR,
};

export const UdbApplicationGroup: RoleGroup = {
  roles: Roles.ROLES_UDB_APPLICATION,
};

export const IViewGroup: RoleGroup = {
  roles: Roles.ROLES_IVIEW,
};

export const LocAppGroup: RoleGroup = {
  roles: Roles.ROLES_LOC_APPLICATION,
};

export const ContactAppGroup: RoleGroup = {
  roles: Roles.ROLES_CONTACTS_APPLICATION,
};

export const ScheduleHistoryGroup: RoleGroup = {
  roles: Roles.ROLES_SCHEDULE_HISTORY_APPLICATION,
};

export const ScheduleAppGroup: RoleGroup = {
  roles: Roles.ROLES_SCHEDULE_APPLICATION,
};

export const ProductAppGroup: RoleGroup = {
  roles: Roles.ROLES_PRODUCT_APPLICATION,
};

export const IngredientsAppGroup: RoleGroup = {
  roles: Roles.ROLES_INGREDIENTS_APPLICATION,
};

export const FacilitiesModifyGroup: RoleGroup = {
  roles: [
    Roles.ROLE_IN_HOUSE_MIS_MANAGER,
    Roles.ROLE_RABBINIC_COORDINATOR,
    Roles.ROLE_RC_SUPPORT_STAFF,
  ],
};

export const ApprovalGroup: RoleGroup = {
  roles: [
    Roles.ROLE_IN_HOUSE_MIS_MANAGER,
    Roles.ROLE_RABBINIC_COORDINATOR,
    Roles.ROLE_RC_SUPPORT_STAFF,
  ],
};

export const RfrVisitsGroup: RoleGroup = {
  roles: Roles.ROLES_MANAGE_VISITS,
};

export const RfrContactsGroup: RoleGroup = {
  roles: [
    ...Roles.ROLES_ALL_RC,
    ...Roles.ROLES_ALL_INTERNAL_STAFF,
    Roles.ROLE_RFR_SENIOR,
    Roles.ROLE_MIS,
    Roles.ROLE_IN_HOUSE_MIS_MANAGER,
  ],
};

export const FinancialsEmulationGroup: RoleGroup = {
  roles: [
    Roles.ROLE_ACCOUNTING,
    Roles.ROLE_RABBINIC_COORDINATOR,
    Roles.ROLE_RC_SUPPORT_STAFF,
    Roles.ROLE_MIS,
    Roles.ROLE_IN_HOUSE_MIS_MANAGER,
  ],
};
